module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "dedit"
  }, [_vm._v("Dedicated to the courage and sacrifice of the men and women who served, as well as the patriots of the resistance groups with whom they fought and died.")]), _vm._v(" "), _c('p', {
    staticClass: "dedict"
  }, [_vm._v("The life that I have")]), _vm._v(" "), _c('p', {
    staticClass: "dedic"
  }, [_vm._v("Is all that I have")]), _vm._v(" "), _c('p', {
    staticClass: "dedic"
  }, [_vm._v("And the life that I have")]), _vm._v(" "), _c('p', {
    staticClass: "dedic"
  }, [_vm._v("Is yours")]), _vm._v(" "), _c('p', {
    staticClass: "dedict"
  }, [_vm._v("The love that I have")]), _vm._v(" "), _c('p', {
    staticClass: "dedic"
  }, [_vm._v("Of the life that I have")]), _vm._v(" "), _c('p', {
    staticClass: "dedic"
  }, [_vm._v("Is yours and yours and yours")]), _vm._v(" "), _c('p', {
    staticClass: "dedict"
  }, [_vm._v("A sleep I shall have")]), _vm._v(" "), _c('p', {
    staticClass: "dedic"
  }, [_vm._v("A rest I shall have")]), _vm._v(" "), _c('p', {
    staticClass: "dedic"
  }, [_vm._v("Yet death will be but a pause")]), _vm._v(" "), _c('p', {
    staticClass: "dedict"
  }, [_vm._v("For the peace of my years")]), _vm._v(" "), _c('p', {
    staticClass: "dedic"
  }, [_vm._v("In the long green grass")]), _vm._v(" "), _c('p', {
    staticClass: "dedic"
  }, [_vm._v("Will be yours and yours")]), _vm._v(" "), _c('p', {
    staticClass: "dedic"
  }, [_vm._v("and yours")]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_vm._v("SOE agent Violette Szabo, "), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Glossary#rgloss_48",
      "id": "gloss_48"
    }
  }, [_vm._v("GC")]), _vm._v(", used these lines as a code poem on her second and final mission. It was written by Leo Marks, a SOE cryptographer, after he learned of the death of his fiancée. He provided it to Szabo, but did not tell her of its origin.")]), _vm._v(" "), _c('p', {
    staticClass: "dedir"
  }, [_vm._v("– Leo Marks, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Between Silk and Cyanide")])]), _vm._v(" "), _c('p', {
    staticClass: "dedir"
  }, [_vm._v("(London: Harper Collins, 1998)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e12992","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Dedication.vue
// module id = 69
// module chunks = 0